export const PARAMS_TO_IGNORE = 
    [
        "EQ Frequency 1 gain",
        "type",
        "EQ Frequency 5 gain",
        "EQ Frequency 8 gain",
        "Pulse Width",
        "algorithm",
        "width",
        "speed",
        "Configuration",
        "Feedback",
        "list",
        "Drive",
        "enabled",
        "Enabled",
        "pitchBend",
        "Polyphony",
        "stages",
        "smoothness",
        "Custom Oscillator Type",
        "lengthFactor",
        "Oscillator Type",
        "resolution",
        "Harmonics",
        "Level",
        "Filter Cutoff (hi-pass)",
        "Filter Q (hi-pass)",
        "Partials",
        "Partial Count",
        "LFO Type", // todo: mmake this an OptionParameter so that it can be sent
    ];

export const PARAMS_TO_LOWER_DEPTH = [
    "detune",
    "harmonicity",
    "feedback",
    "modulationindex"
];

export const PARAMS_TO_NOT_MODULATE = [
    "Sustain",
    "steps",
    "Resolution",
    "Probability",
    "lengthFactor",
    "resolution",
    "probability",
    "Decay",
    "Attack",
    "Release"
];


export const getTrackParameters = (device, effect) => {
    let parameters = device.getParameters ? device.getParameters() : device.parameters;
    
    return parameters
        .filter(x => x.automatable && !x.config.isDb)
        .filter(x => !x.hasMacro)
        .filter(x => !x.isMapped)
        .filter(
            x => !PARAMS_TO_IGNORE.includes(x.name));
};

